











































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { faPhoneAlt, faCheckCircle } from '@fortawesome/pro-regular-svg-icons';

@Component<IsiContent>({
    props: {
        position: String,
        isCollapsed: Boolean,
    },
    icons: {
        faPhoneAlt,
        faCheckCircle,
    },
})
export default class IsiContent extends Vue {
    @Prop()
    public brkPoints!: object;
}
